import React, { useState, useEffect } from 'react';
import { default as t } from '../../../utils/i18n';
import './final-report-graph.scss';
import { generateSocialResultGraph } from './social-result';
import { generateActualPlanned } from './actual-vs-planned';
import { generateCurrentVsLast } from './current-vs-last';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import { Loader } from '../../atoms';

const FinalReportGraph = ({ data, handleOpenSliderModal, openSliderModal, kpiList }) => {
  const [currentvsLastMsg, setCurrentvsLastMsg] = useState(false);
  const [currentvsLastNodata, setCurrentvsLastNodata] = useState(false);
  const [actualVsPlanNodata, setActualVsPlanNodata] = useState(false);
  const [funnelGraphData, setFunnelGraphData] = useState([]);
  const [loader, setLoader] = useState(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    generateCurrentVsLast({ data, kpiList, setCurrentvsLastMsg, setCurrentvsLastNodata });
    generateActualPlanned({ data, kpiList, setActualVsPlanNodata });
    getFunnelGraphData();
  }, []);

  const getFunnelGraphData = () => {
    let resultedData = data.reportData.metrics_for_funnel_graph;
    setFunnelGraphData(resultedData);
  };

  const handleBackClick = () => {
    document.body.style.overflow = 'auto';
    // setGraphViewToggle(false);
    setTimeout(() => {
      handleOpenSliderModal(true);
    }, 1000);
    // setAttributeDetailModalView(!props?.openSliderModal );
  };
  const handleDownloadModalSSClick = () => {
    setLoader(true);
    const icon = document.querySelector('.download-modal-icon');
    icon.classList.add('active');
    setTimeout(() => {
      var testdiv = document.getElementById('snapshot-graph');
      html2canvas(testdiv, {
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight, // There is no deviation from the top so there is no need to modify
        backgroundColor: 'white',
        allowTaint: true,
        useCORS: true,
      }).then(canvas => {
        let pxFullHeight = canvas.height;
        const image = { type: 'jpeg', quality: 0.98 };
        const margin = [0.1, 0.1];
        let imgWidth = 8.5;
        let pageHeight = 11;
        let innerPageWidth = imgWidth - margin[0] * 2;
        let innerPageHeight = pageHeight - margin[1] * 2;
        let pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
        let nPages = Math.ceil(pxFullHeight / pxPageHeight);

        // Define pageHeight separately so it can be trimmed on the final page.
        let sepratePageHeight = innerPageHeight;

        // Create a one-page canvas to split up the full image.
        let pageCanvas = document.createElement('canvas');
        let pageCtx = pageCanvas.getContext('2d');
        pageCanvas.width = canvas.width;
        pageCanvas.height = pxPageHeight;
        // Initialize the PDF.
        let pdf = new jsPdf('p', 'in', [8.5, 11]);
        for (let page = 0; page < nPages; page++) {
          // Trim the final page to reduce file size.
          if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
            pageCanvas.height = pxFullHeight % pxPageHeight;
            sepratePageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
          }
          // Display the page.
          let w = pageCanvas.width;
          let h = pageCanvas.height;
          pageCtx.fillStyle = 'white';
          pageCtx.fillRect(0, 0, w, h);
          pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
          // Add the page to the PDF.
          if (page > 0) pdf.addPage();
          let imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
          pdf.addImage(
            imgData,
            image.type,
            margin[1],
            margin[0],
            innerPageWidth,
            sepratePageHeight
          );
        }
        pdf.save(`${data?.reportId}_${data?.reportingStartDate}_${data?.reportingEndDate}_graph.pdf`);
        icon.classList.remove('active');
        setLoader(false);
      });
    });
  };
  const getValueOfKpi = kpi => {
    let val;
    val = funnelGraphData && funnelGraphData[kpi] ? funnelGraphData[kpi]?.toFixed(3) : 'No data';
    return val;
  };

  const checkConversions = () => {
    return data?.campaigns?.some(campaign => campaign.objective === 'CONVERSIONS');
  };
  return (
    <>
      {loader ? <Loader /> : null}
      <div className={`attribute-detail-view-overlay graphs ${openSliderModal ? 'show' : 'hide'}`}>
        <div className="attribute-detail-view">
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
            <DownloadIcon className="download-modal-icon" />
            <button className="download-snapshot" onClick={() => handleDownloadModalSSClick()}>
              <i className="eva eva-camera-outline"></i>
              {t('download.snapshot.button.label')}
            </button>
          </div>
          <section>
            <div>
              <div className="head-title">
                <span>
                  {t('graphical.view.for')} &nbsp;
                  <b>{data?.reportName}</b>
                </span>
              </div>
            </div>
            <div className="card-section">
              <div className="first-card">
                <div className="left-sec">
                  <div className="title-sec">
                    <h1 title={data?.reportName}>{data?.reportName}</h1>
                    <span>
                      <i className="eva eva-pin-outline"></i>
                      <div
                        className="location"
                        title={
                          data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'
                        }
                      >
                        {data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'}
                      </div>
                    </span>
                  </div>
                </div>
                <div className="right-sec">
                  <div className="report-date">
                    <p>{t('reportTable.text.advertiser')}</p>
                    <span className="advertiser" title={data?.advertiser}>
                      {data?.advertiser}
                    </span>
                  </div>
                  <div className="report-date">
                    <p> {t('define.stepper.dateRange')}</p>
                    <span>
                      {data?.reportingStartDate}-{data?.reportingEndDate}
                    </span>
                  </div>
                </div>
              </div>
              <div className="second-card">
                <div className="first-row">
                  <div>
                    <p title={'Planned spend ' + data?.currency}>
                      {t('final.output.planned.spend')} ({data?.currency})
                    </p>
                    <span>{data?.plannedSpend}</span>
                  </div>
                  <div>
                    <p>
                      {t('contentTable.acutalSpent.label')} ({data?.currency})
                    </p>
                    <span>{data?.actualSpend}</span>
                  </div>
                  <div>
                    <p>{t('final.output.spend.pacing')}</p>
                    <span>{data?.spendPacing}</span>
                  </div>
                  <div>
                    <p>{t('final.output.panned.impressions')}</p>
                    <span>{data?.plannedImpressions}</span>
                  </div>
                  <div>
                    <p>{t('final.output.planned.dates')}</p>
                    <span>{data?.plannedDates}</span>
                  </div>
                </div>
                <div className="seprator"></div>
                <div className="second-row">
                  <div className="row-data">
                    <div>
                      <p title={t('final.output.days.elapsed')}>{t('final.output.days.elapsed')}</p>
                      <span title={data?.daysElapsed}>{data?.daysElapsed}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.elapsed') + ' %'}>
                        {t('final.output.days.elapsed')} %
                      </p>
                      <span title={data?.daysElapsedPercent}>{data?.daysElapsedPercent}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.remaining')}>
                        {t('final.output.days.remaining')}
                      </p>
                      <span title={data?.daysRemaining}>{data?.daysRemaining}</span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.primaryKpi')}>
                        {t('define.matric.table.primaryKpi')}{' '}
                      </p>
                      <span
                        title={
                          data?.primaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.primaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.pacing')}>
                        {t('final.output.primary.kpi.pacing')}{' '}
                      </p>
                      <span title={data?.primaryKpiPacing}>{data?.primaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.planned.target')}>
                        {t('final.output.primary.kpi.planned.target')}{' '}
                      </p>
                      <span title={data?.primaryKpiPlannedTarget}>
                        {data?.primaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.secondaryKpi')}>
                        {t('define.matric.table.secondaryKpi')}
                      </p>
                      <span
                        title={
                          data?.secondaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.secondaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.pacing')}>
                        {t('final.output.secondary.kpi.pacing')}
                      </p>
                      <span title={data?.secondaryKpiPacing}>{data?.secondaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.planned.target')}>
                        {t('final.output.secondary.kpi.planned.target')}
                      </p>
                      <span title={data?.secondaryKpiPlannedTarget}>
                        {data?.secondaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {checkConversions() ? (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('conversion.graph')}</h3>
                    </div>
                    <div className="chart-container">
                      <div className="header-val">
                        <div className="top-header">
                          <span className="header-top">Amount Spent</span>
                          <span>{getValueOfKpi('ad_spend')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">CPM</span>
                          <span>{getValueOfKpi('branding_ad_cpm')}</span>
                        </div>
                        <div className="actual-funnel separated_part">
                          <div className="separation separation_1">
                            <div
                              className="in-line"
                              data-tip="Impressions <br> 29,218,726"
                              data-for="tool-tip"
                            >
                              <span className="header text-cen">Impressions</span>
                              <span>{getValueOfKpi('branding_ad_impressions')}</span>
                              {/* <span className='side-header align-data'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                            </div>
                            <div
                              className="in-line"
                              data-tip="Reach <br> 457,864"
                              data-for="tool-tip"
                            >
                              <span className="header text-cen">Reach</span>
                              <span>{getValueOfKpi('branding_ad_reach')}</span>
                              {/* <span className='side-header align-data'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Frequency</span>
                          <span>{getValueOfKpi('perf_ad_frequency')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per link click</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_link_click')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-2 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header purchase-text justify_centre">
                                  Link clicks
                                </span>
                                <span>{getValueOfKpi('perf_ad_link_clicks')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">CTR(Link click through rate)</span>
                          <span>{getValueOfKpi('perf_ad_link_click_through_rate')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per landing view</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_landing_page_view')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-3 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Landing page views</span>
                                <span>{getValueOfKpi('perf_ad_landing_page_views')}</span>
                                {/* <span className='side-header align-data'> <i className="eva eva-arrow-upward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Link clicks to landing</span>
                          <span>{getValueOfKpi('perf_ad_landing_page_view_rate')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per view content</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_content')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-4 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">View Content</span>
                                <span>{getValueOfKpi('perf_ad_view_content')}</span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header"></span>
                          <span>N/A</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per adds to cart</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_adds_to_cart')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-5 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Adds to cart</span>
                                <span>{getValueOfKpi('perf_ad_adds_to_cart')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header"></span>
                          <span>N/A</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per purchase</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_purchase')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-6 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Purchases</span>
                                <span>{getValueOfKpi('perf_ad_purchases')}</span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Conversion rate</span>
                          <span>{getValueOfKpi('perf_ad_purchase_conversion_rate')}</span>
                        </div>
                      </div>

                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Purchase ROAS</span>
                          <span>{getValueOfKpi('perf_ad_purchase_roas')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-7 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Revenue</span>
                                <span
                                  className="text_wrap"
                                  title={getValueOfKpi('perf_ad_revenue')}
                                >
                                  {getValueOfKpi('perf_ad_revenue')}
                                </span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">AOV</span>
                          <span>{getValueOfKpi('perf_ad_aov')}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {data?.type === 'LIVE' && (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('current.last.graph')}</h3>
                      {currentvsLastMsg && (
                        <div className="totalValueNote">
                          <span className="boldText">
                            {' '}
                            <i className="eva eva-info-outline"></i>
                          </span>
                          {t('graph.current.note')}{' '}
                        </div>
                      )}
                    </div>
                    {currentvsLastNodata && <h3>{t('no.data.found')}</h3>}
                    <div id="current_vs_last"></div>
                    <div id="current_vs_last2"></div>
                    <div id="current_vs_last3"></div>
                  </div>
                )}
                {!actualVsPlanNodata && (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('actual.planned.graph')}</h3>
                    </div>
                    {actualVsPlanNodata && <h3>{t('no.data.found')}</h3>}
                    <div className="individual-graph" id="actual_vs_planned"></div>
                  </div>
                )}

                {data?.reportData?.breakdowns.map(breakDown => {
                  setTimeout(() => {
                    generateSocialResultGraph({
                      breakDown,
                      kpiList,
                      primaryKpi: data?.primaryKpi,
                      currency: data?.currency,
                    });
                  });
                  return (
                    <div className="graph-card">
                      <div className="title-Container">
                        <h3>{breakDown?.title}</h3>
                        <div className="totalValueNote">
                          <span className="boldText">
                            {' '}
                            <i className="eva eva-info-outline"></i>
                          </span>
                          {t('graph.breakdown.note')}{' '}
                        </div>
                      </div>
                      <div className="individual-graph" id={'social' + breakDown.id}></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
          <section id="snapshot-graph">
            <div>
              <div className="head-title">
                <span>
                  {t('graphical.view.for')} &nbsp;
                  <b>{data?.reportName}</b>
                </span>
              </div>
            </div>
            <div className="card-section">
              <div className="first-card">
                <div className="left-sec">
                  <div className="title-sec">
                    <h1 title={data?.reportName}>{data?.reportName}</h1>
                    <span>
                      <i className="eva eva-pin-outline"></i>
                      <div
                        className="location"
                        title={
                          data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'
                        }
                      >
                        {data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'}
                      </div>
                    </span>
                  </div>
                </div>
                <div className="right-sec">
                  <div className="report-date">
                    <p>{t('reportTable.text.advertiser')}</p>
                    <span className="advertiser" title={data?.advertiser}>
                      {data?.advertiser}
                    </span>
                  </div>
                  <div className="report-date">
                    <p> {t('define.stepper.dateRange')}</p>
                    <span>
                      {data?.reportingStartDate}-{data?.reportingEndDate}
                    </span>
                  </div>
                </div>
              </div>
              <div className="second-card">
                <div className="first-row">
                  <div>
                    <p title={'Planned spend ' + data?.currency}>
                      {t('final.output.planned.spend')} ({data?.currency})
                    </p>
                    <span>{data?.plannedSpend}</span>
                  </div>
                  <div>
                    <p>
                      {t('contentTable.acutalSpent.label')} ({data?.currency})
                    </p>
                    <span>{data?.actualSpend}</span>
                  </div>
                  <div>
                    <p>{t('final.output.spend.pacing')}</p>
                    <span>{data?.spendPacing}</span>
                  </div>
                  <div>
                    <p>{t('final.output.panned.impressions')}</p>
                    <span>{data?.plannedImpressions}</span>
                  </div>
                  <div>
                    <p>{t('final.output.planned.dates')}</p>
                    <span>{data?.plannedDates}</span>
                  </div>
                </div>
                <div className="seprator"></div>
                <div className="second-row">
                  <div className="row-data">
                    <div>
                      <p title={t('final.output.days.elapsed')}>{t('final.output.days.elapsed')}</p>
                      <span title={data?.daysElapsed}>{data?.daysElapsed}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.elapsed') + ' %'}>
                        {t('final.output.days.elapsed')} %
                      </p>
                      <span title={data?.daysElapsedPercent}>{data?.daysElapsedPercent}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.remaining')}>
                        {t('final.output.days.remaining')}
                      </p>
                      <span title={data?.daysRemaining}>{data?.daysRemaining}</span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.primaryKpi')}>
                        {t('define.matric.table.primaryKpi')}{' '}
                      </p>
                      <span
                        title={
                          data?.primaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.primaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.pacing')}>
                        {t('final.output.primary.kpi.pacing')}{' '}
                      </p>
                      <span title={data?.primaryKpiPacing}>{data?.primaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.planned.target')}>
                        {t('final.output.primary.kpi.planned.target')}{' '}
                      </p>
                      <span title={data?.primaryKpiPlannedTarget}>
                        {data?.primaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.secondaryKpi')}>
                        {t('define.matric.table.secondaryKpi')}
                      </p>
                      <span
                        title={
                          data?.secondaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.secondaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.pacing')}>
                        {t('final.output.secondary.kpi.pacing')}
                      </p>
                      <span title={data?.secondaryKpiPacing}>{data?.secondaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.planned.target')}>
                        {t('final.output.secondary.kpi.planned.target')}
                      </p>
                      <span title={data?.secondaryKpiPlannedTarget}>
                        {data?.secondaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {checkConversions() ? (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('conversion.graph')}</h3>
                    </div>
                    <div className="chart-container">
                      <div className="header-val">
                        <div className="top-header">
                          <span className="header-top">Amount Spent</span>
                          <span>{getValueOfKpi('ad_spend')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">CPM</span>
                          <span>{getValueOfKpi('branding_ad_cpm')}</span>
                        </div>
                        <div className="actual-funnel separated_part">
                          <div className="separation separation_1">
                            <div
                              className="in-line"
                              data-tip="Impressions <br> 29,218,726"
                              data-for="tool-tip"
                            >
                              <span className="header text-cen">Impressions</span>
                              <span>{getValueOfKpi('branding_ad_impressions')}</span>
                              {/* <span className='side-header align-data'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                            </div>
                            <div
                              className="in-line"
                              data-tip="Reach <br> 457,864"
                              data-for="tool-tip"
                            >
                              <span className="header text-cen">Reach</span>
                              <span>{getValueOfKpi('branding_ad_reach')}</span>
                              {/* <span className='side-header align-data'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Frequency</span>
                          <span>{getValueOfKpi('perf_ad_frequency')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per link click</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_link_click')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-2 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header purchase-text justify_centre">
                                  Link clicks
                                </span>
                                <span>{getValueOfKpi('perf_ad_link_clicks')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">CTR(Link click through rate)</span>
                          <span>{getValueOfKpi('perf_ad_link_click_through_rate')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per landing view</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_landing_page_view')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-3 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Landing page views</span>
                                <span>{getValueOfKpi('perf_ad_landing_page_views')}</span>
                                {/* <span className='side-header align-data'> <i className="eva eva-arrow-upward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Link clicks to landing</span>
                          <span>{getValueOfKpi('perf_ad_landing_page_view_rate')}</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per view content</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_content')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-4 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">View Content</span>
                                <span>{getValueOfKpi('perf_ad_view_content')}</span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header"></span>
                          <span>N/A</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per adds to cart</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_adds_to_cart')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-5 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Adds to cart</span>
                                <span>{getValueOfKpi('perf_ad_adds_to_cart')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header"></span>
                          <span>N/A</span>
                        </div>
                      </div>
                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Cost per purchase</span>
                          <span>{getValueOfKpi('perf_ad_cost_per_purchase')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-6 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Purchases</span>
                                <span>{getValueOfKpi('perf_ad_purchases')}</span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">Conversion rate</span>
                          <span>{getValueOfKpi('perf_ad_purchase_conversion_rate')}</span>
                        </div>
                      </div>

                      <div className="first-row">
                        <div className="kpi-val">
                          <span className="side-header">Purchase ROAS</span>
                          <span>{getValueOfKpi('perf_ad_purchase_roas')}</span>
                        </div>
                        <div className="actual-funnel">
                          <div className="row-7 separated_part">
                            <div className="separation">
                              <div className="in-line">
                                <span className="header justify_centre">Revenue</span>
                                <span
                                  className="text_wrap"
                                  title={getValueOfKpi('perf_ad_revenue')}
                                >
                                  {getValueOfKpi('perf_ad_revenue')}
                                </span>
                                {/* <span className='side-header align-data purchase-text'> <i className="eva eva-arrow-downward-outline"></i>7.61</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="kpi-val">
                          <span className="side-header">AOV</span>
                          <span>{getValueOfKpi('perf_ad_aov')}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {data?.type === 'LIVE' && (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('current.last.graph')}</h3>
                      {currentvsLastMsg && (
                        <div className="totalValueNote">
                          <span className="boldText">
                            {' '}
                            <i className="eva eva-info-outline"></i>
                          </span>
                          {t('graph.current.note')}{' '}
                        </div>
                      )}
                    </div>
                    {currentvsLastNodata && <h3>{t('no.data.found')}</h3>}
                    <div id="current_vs_last_ss"></div>
                    <div id="current_vs_last2_ss"></div>
                    <div id="current_vs_last3_ss"></div>
                  </div>
                )}
                {!actualVsPlanNodata && (
                  <div className="graph-card">
                    <div className="title-Container">
                      <h3>{t('actual.planned.graph')}</h3>
                    </div>
                    {actualVsPlanNodata && <h3>{t('no.data.found')}</h3>}
                    <div className="individual-graph" id="actual_vs_planned_ss"></div>
                  </div>
                )}

                {data?.reportData?.breakdowns.map(breakDown => {
                  setTimeout(() => {
                    generateSocialResultGraph({
                      breakDown,
                      kpiList,
                      primaryKpi: data?.primaryKpi,
                      currency: data?.currency,
                      fromSS: true,
                    });
                  }, 3000);
                  return (
                    <div className="graph-card">
                      <div className="title-Container">
                        <h3>{breakDown?.title}</h3>
                        <div className="totalValueNote">
                          <span className="boldText">
                            {' '}
                            <i className="eva eva-info-outline"></i>
                          </span>
                          {t('graph.breakdown.note')}{' '}
                        </div>
                      </div>
                      <div className="totalValueNote graph">
                        <span className="boldText">
                          {' '}
                          <i className="eva eva-info-outline"></i>
                        </span>
                        {t('graph.pdf.labelNote')}{' '}
                      </div>
                      <div className="labels" id={'label' + breakDown.id}></div>
                      <div className="individual-graph" id={'socialss' + breakDown.id}></div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default FinalReportGraph;
